// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iweb-loading-container .iweb-loading-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 998;
  touch-action: none;
  background-color: rgba(255, 255, 255, 0.55);
}
.iweb-loading-container .iweb-loading-wrapper {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  transition: opacity 200ms;
  z-index: 999;
}
.iweb-loading-container .iweb-loading-wrapper-text {
  margin-top: 12px;
}
.iweb-loading-container .iweb-loading-wrapper-icon {
  width: 48px;
  height: 48px;
}
.iweb-loading-container .iweb-loading-wrapper-enter {
  opacity: 0;
}
.iweb-loading-container .iweb-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@ali/infinite-webui/es/web-components/Loading/loading.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".iweb-loading-container .iweb-loading-mask {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 998;\n  touch-action: none;\n  background-color: rgba(255, 255, 255, 0.55);\n}\n.iweb-loading-container .iweb-loading-wrapper {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 100%;\n  transition: opacity 200ms;\n  z-index: 999;\n}\n.iweb-loading-container .iweb-loading-wrapper-text {\n  margin-top: 12px;\n}\n.iweb-loading-container .iweb-loading-wrapper-icon {\n  width: 48px;\n  height: 48px;\n}\n.iweb-loading-container .iweb-loading-wrapper-enter {\n  opacity: 0;\n}\n.iweb-loading-container .iweb-loading-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
